import {Component} from 'react';
import PropTypes from 'prop-types';

import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

import agentConnectionsUpdatedEvent from '../../events/agentConnectionsUpdated.event.crm';
import conversationMessageEvent from '../../events/conversationMessage.event.crm';
import ticketClosedEvent from '../../events/ticketClosed.event.crm';
import ticketCreatedEvent from '../../events/ticketCreated.event.crm';

import agentConnectionsUpdatedSocket from '../../sockets/agentConnectionsUpdated.socket.crm';
import conversationMessageSocket from '../../sockets/conversationMessage.socket.crm';
import ticketClosedSocket from '../../sockets/ticketClosed.socket.crm';
import ticketCreatedSocket from '../../sockets/ticketCreated.socket.crm';

class CrmListenerContainer extends Component {
  static propTypes = {
    subscribe: PropTypes.func,
  };

  componentDidMount() {
    
    this.props.subscribe(
      agentConnectionsUpdatedSocket.subscribe((data) => {
        agentConnectionsUpdatedEvent.publish(data);
      }),
      conversationMessageSocket.subscribe((data) => {
        // console.log('conversation-message', data);
        conversationMessageEvent.publish(data);
      }),
      ticketCreatedSocket.subscribe((data) => {
        // console.log('crm-ticket-created', data);
        ticketCreatedEvent.publish(data);
      }),
      ticketClosedSocket.subscribe((data) => {
        // console.log('crm-ticket-closed', data);
        ticketClosedEvent.publish(data);
      })
    );
  }

  

  render() {
    return null;
  }
}

export default subscriptionHOC(CrmListenerContainer);
